import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { reduceMetadata } from '~/tools/mll/helpers';
import './styles.scss';

class FighterRoster extends Component {
  state = {
    loaded: false,
    teams: []
  }

  componentDidMount = () => {
    this.fetchFighters().then(() => {
      this.scrollToView()
    })
  }

  fetchFighters = () => {
    const { apiBaseUrl, internalName, navigation } = window.settings;
    const fightersNav = _.filter(navigation.primary, { 'displayedPath': '/fighters' })[0]
    return axios.get(`${apiBaseUrl}/search/v2/list?site=${internalName}&type=roster`)
    .then(res => {
      let teams = this.sortFightersAlphabetically(res.data[0].teams)
      let fighters = _.get(fightersNav, 'items')
      this.setState({ teams, fighters })
    })
    .catch(err => {
      console.log(err)
    })
  }

  scrollToView = () => {
    const { hash } = window.location
    this.setState({ loaded: true })
    if (hash !== '') {
      const elem = document.getElementById(hash.slice(1))
      elem.scrollIntoView()
      window.scrollBy(0, -70)
    }
  }

  getToFighterPage = (fighter) => {
    window.location = _.get(fighter, 'data.permalink')
  }

  sortFightersAlphabetically = (data) => {
    return _.map(data, t => (
      { name: t.name, players: _.sortBy(t.players, p => p.lastName) }
    ))
  }

  renderFighters = (weightclass, index) => {
    return (
    this.state.teams.length > 0 &&
      <div key={index}>
        <h1 id={`${weightclass.name.replace(' ','')}`} className='weightclass site-border-color'>{weightclass.name}</h1> 
        <div className='fighters-wrapper'>
          { weightclass.players.map((fighter, i) => (
            <div className='fighter-details' onClick={() => this.getToFighterPage(fighter)} key={i}>
              <div className='fighter-avatar'>
                <img src={_.get(fighter, 'data.images._3x4.url')} alt={`${fighter.lastName} headshot`}/>
              </div>
              <div className='fighter-stats'>
                <div className='fighter-info'>
                  <div className='fighter-flag'>
                    <img src={_.get(fighter, 'data.images._1x1.url')} alt='country flag'/>
                  </div>
                  <div className='fighter-fullname'>
                    <span>{fighter.firstName}</span>
                    <span>{fighter.lastName}</span>
                  </div>
                </div>
                <div className='fighter-record'>
                  <span className='record site-color'>
                    {reduceMetadata(fighter.data.metadata).mma_record}
                  </span>
                  <span className='score'>
                    {`(${reduceMetadata(fighter.data.metadata).pfl_record})`}
                  </span>
                </div>
              </div>
              <div className='fighter-charac'>
                <div>
                  <span>Weight</span>
                  <span>{fighter.weight}</span>
                </div>
                <div>
                  <span>Height</span>
                  <span>{fighter.height}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className='fighters-roster'>
        { this.state.loaded ?
          this.state.fighters ? this.state.fighters.map(el => {
            return this.state.teams.filter(ell => ell.name === el.title).map((weightclass, i) => {
              return this.renderFighters(weightclass, i)
            })
          }) : this.state.teams.map((weightclass, i) => { 
            return this.renderFighters(weightclass, i)
          }) : <div/> 
        }
      </div>
    )
  }
}

export default FighterRoster;